export const patientCreateOrUpdate = {
  patientCreateError: "Sorry, there was an error creating the patient",
  patientUpdateError: "Sorry, there was an error updating the patient"
};
